import moment from 'moment';

export function formatDateDD(
  d: number | string | Date,
  isUTC?: boolean,
  showYear = true,
): string {
  let date = isUTC ? moment.utc(d) : moment(d);
  return showYear ? date.format('DD MMM YYYY') : date.format('DD MMM');
}

export function formatDateDash(
  d: number | string | Date,
  isUTC?: boolean,
): string {
  let date = isUTC ? moment.utc(d) : moment(d);
  return date.format('YYYY-MM-DD');
}

export function formatDateFull(
  d: string,
  isUTC?: boolean,
  showDay = true,
): string {
  let date = isUTC ? moment.utc(d) : moment(d);
  return showDay
    ? date.format('dddd, D MMMM YYYY')
    : date.format('DD MMMM YYYY');
}

export function formatDateTime(d: number | string | Date, isUTC?: boolean) {
  let date = isUTC ? moment.utc(d) : moment(d);
  return date.format('D MMM h:mm a');
}

export function formatDateFullWithHours(d: string, isUTC?: boolean) {
  let date = isUTC ? moment.utc(d) : moment(d);
  return date.format('D MMMM YYYY, h:mm a');
}
